import axios from "axios";

// pass new generated access token here
let token = localStorage.getItem("token", null); //access token

const API_VERSION = '/v1';

//LIVE url

/* export const IMAGE_URL = import.meta.env.VITE_IMAGE_BASE_URL || "test new";
export const API_URL = import.meta.env.VITE_API_BASE_URL || "test"; */
//export const API_URL1 = import.meta.env.VITE_API_BASE_URL;


export const IMAGE_URL = process.env.REACT_APP_IMAGE_BASE_URL;   //'http://192.168.1.9:3200/public/uploads/'
export const API_URL =    process.env.REACT_APP_API_BASE_URL; //'http://localhost:3200/api'

console.log("process.env:", process.env);


const axiosApi = axios.create({
    baseURL : API_URL,
});

axiosApi.interceptors.response.use(
    (response) => response,
    //error => Promise.reject(error)
    (error) => {
        if(error.response && error.response.status === 401){
            const errorMessage = error.response.data.message || "";
            
            // Check if the error message contains "TokenExpiredError"
            if(errorMessage.includes('TokenExpiredError')){
                 // Dispatch the logout action via the Redux store
                //store.dispatch(logoutUser());

                //Optionally, reject the error
                return Promise.reject('Token expierd, Logging out ... ');

            }
            else{
                return Promise.reject(error);
            }
        }
        else{
            return Promise.reject(error);
        }
    }

);

export async function get(url, config ={}){

  console.log("API_URL",process.env.REACT_APP_API_BASE_URL);
    return await axiosApi
    .get(url, { ...config })
    .then((response) => response.data);
}

export async function post(url, data, config = {}){
    return axiosApi
    .post(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function put(url,data, config = {}){
    return axiosApi
    .put(url, {...data},{...config})
    .then((response) =>  response.data);
}

export async function patch(url, data, config = {}){
    return axiosApi
    .patch(url, {...data}, {...config})
    .then((response) => response.data);
}

export async function del(url, config = {}){
    return await axiosApi
    .delete(url, {...config})
    .then((response) =>  response.data);
}

/* export async function postMultipart(url, formData) {
  try {
    const response = await axiosApi.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return handleResponse(response);
  } catch (error) {
    console.error('Error in postMultipart:', error);
    // Handle error appropriately (e.g., throw, return specific error object)
    throw error;
  }
} */

  export async function postMultipart(url, data, config = {}){
    const formData = new FormData();

    for(const key in data){
        if(Object.prototype.hasOwnProperty.call(data,key)){
            formData.append(key, data[key]);
        }
    }

    const multipartConfig = {
        ...config,
        headers : {
            ...config.headers,
            "Content-Type": "multipart/form-data",
        },
    };

    return axiosApi
    .post(url, formData, multipartConfig)
    .then((response) => response.data);
  }

  export async function patchMultipart(url, data, config = {}) {
    const formData = new FormData();
  
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        formData.append(key, data[key]);
      }
    }
  
    const multipartConfig = {
      ...config,
      headers: {
        ...config.headers,
        "Content-Type": "multipart/form-data",
      },
    };
  
    return axiosApi
      .patch(url, formData, multipartConfig)
      .then((response) => response.data);
  }